// utils/trialUtils.js
// 체험일수 계산 관련 공통 유틸리티 함수

/**
 * 체험 시작일로부터 남은 체험 일수를 계산합니다.
 * @param {string|Date} trialStartDate - 체험 시작일 (ISO 문자열 또는 Date 객체)
 * @param {number} trialPeriodDays - 체험 기간 일수 (기본값: 7일)
 * @returns {number} 남은 체험 일수 (0 이상)
 */
export const calculateRemainingDays = (trialStartDate, trialPeriodDays = 7) => {
    if (!trialStartDate) return 0;
    
    try {
        const startDate = new Date(trialStartDate);
        const currentDate = new Date();
        const diffTime = currentDate - startDate;
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        return Math.max(0, trialPeriodDays - diffDays);
    } catch (error) {
        console.error('체험일수 계산 오류:', error);
        return 0;
    }
};

/**
 * 체험 시작일로부터 경과한 일수를 계산합니다.
 * @param {string|Date} trialStartDate - 체험 시작일 (ISO 문자열 또는 Date 객체)
 * @returns {number} 경과한 일수
 */
export const calculateDaysUsed = (trialStartDate) => {
    if (!trialStartDate) return 0;
    
    try {
        const startDate = new Date(trialStartDate);
        const currentDate = new Date();
        const diffTime = currentDate - startDate;
        return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    } catch (error) {
        console.error('경과일수 계산 오류:', error);
        return 0;
    }
};

/**
 * 체험이 만료되었는지 확인합니다.
 * @param {string|Date} trialStartDate - 체험 시작일 (ISO 문자열 또는 Date 객체)
 * @param {number} trialPeriodDays - 체험 기간 일수 (기본값: 7일)
 * @returns {boolean} 만료 여부
 */
export const isTrialExpired = (trialStartDate, trialPeriodDays = 7) => {
    return calculateRemainingDays(trialStartDate, trialPeriodDays) === 0;
};







































